var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowhowMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "url(#knowhowMarkGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2452 19.9752C15.1693 19.6811 15.0159 19.4126 14.8011 19.1978C14.5863 18.983 14.3179 18.8296 14.0237 18.7538L8.80895 17.4091C8.71999 17.3838 8.64168 17.3302 8.58592 17.2564C8.53017 17.1827 8.5 17.0927 8.5 17.0002C8.5 16.9077 8.53017 16.8178 8.58592 16.744C8.64168 16.6702 8.71999 16.6166 8.80895 16.5914L14.0237 15.2458C14.3178 15.17 14.5861 15.0168 14.8009 14.8021C15.0157 14.5875 15.1691 14.3192 15.2452 14.0252L16.5899 8.8105C16.6149 8.7211 16.6684 8.6425 16.7423 8.5864C16.8162 8.5303 16.9064 8.5 16.9991 8.5C17.0919 8.5 17.1821 8.5303 17.256 8.5864C17.3299 8.6425 17.3834 8.7211 17.4084 8.8105L18.7523 14.0252C18.8281 14.3194 18.9815 14.5878 19.1963 14.8026C19.4111 15.0174 19.6795 15.1708 19.9737 15.2467L25.1885 16.5905C25.2781 16.6152 25.3572 16.6687 25.4136 16.7427C25.4699 16.8167 25.5004 16.9072 25.5004 17.0002C25.5004 17.0932 25.4699 17.1837 25.4136 17.2577C25.3572 17.3317 25.2781 17.3852 25.1885 17.4099L19.9737 18.7538C19.6795 18.8296 19.4111 18.983 19.1963 19.1978C18.9815 19.4126 18.8281 19.6811 18.7523 19.9752L17.4076 25.19C17.3826 25.2793 17.329 25.358 17.2551 25.414C17.1812 25.4701 17.091 25.5004 16.9983 25.5004C16.9055 25.5004 16.8153 25.4701 16.7414 25.414C16.6675 25.358 16.614 25.2793 16.589 25.19L15.2452 19.9752Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6238 21.2501V23.8001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 22.5251H9.34863",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7986 8.5001V11.9001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4986 10.2002H22.0986",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "knowhowMarkGrad",
    x1: 1.275,
    y1: 0.85,
    x2: 32.725,
    y2: 33.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowhowMark);
export default __webpack_public_path__ + "static/media/knowhow-mark.1d0787bc6a4e5111f8b2761f6b12fd06.svg";
export { ForwardRef as ReactComponent };